var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"transparent",attrs:{"fluid":""}},[_c('bread-crumb',{attrs:{"breadcrumb-data":_vm.breadcrumbData}}),_c('v-sheet',{staticClass:"pa-2 my-6",attrs:{"rounded":"","outlined":"","min-height":"600"}},[_c('stat-dual-summ',{staticClass:"pa-4",attrs:{"data":_vm.statisticData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }